import React from "react";
import { languageService } from "../../../Language/language.service";
import { themeService } from "../../../theme/service/activeTheme.service";
import { commonPageStyle } from "../Summary/styles/CommonPageStyle";
import { commonSummaryStyle } from "../Summary/styles/CommonSummaryStyle.js";
import { ButtonCirclePlus } from "../../Common/Buttons";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { Col, Row } from "reactstrap";

const UISectionHeader = ({ addPermission, title, addCallback, addButtonTitle, postTitleContent, className }) => {
  return (
    <Row className={className}>
      <Col md="12">
        <div style={{ ...themeService(commonPageStyle.commonSummaryHeadingContainer), display: "inline-block" }}>
          <h4 style={themeService(commonPageStyle.commonSummaryHeadingStyle)}>{languageService(title)}</h4>
        </div>
        {addCallback && addPermission ? (
          <div style={{ display: "inline-block", padding: "0 15px" }}>
            <TooltipContainer tooltipText={addButtonTitle}>
              <ButtonCirclePlus handleClick={addCallback} {...themeService(commonSummaryStyle.addButtonStyle({}))} />
            </TooltipContainer>
          </div>
        ) : null}
        {postTitleContent ? postTitleContent : null}
      </Col>
      <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
    </Row>
  );
};

export default UISectionHeader;



// WEBPACK FOOTER //
// ./src/components/Common/UISectionHeader/index.jsx